import { call } from 'redux-saga/effects';
import { simpleQueryFirestoreWithFilter } from '../../components/utility/firestore.helper';

const COLLECTION_NAME = 'users';
const COLLECTION_NAME_ACCOUNT = 'accounts';

// Every localStorage key a session sets. Logout clears all of them.
export const SESSION_KEYS = [
  'id_token',
  'id_role',
  'id_user',
  'account_id',
  'data_account',
  'agency_is_active',
  'user_name',
  'user_email',
  'user_photo',
];

export function clearSession() {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
}

// Name shown in the top bar: the users doc first, the e-mail as last resort.
export function displayNameOf(data, fallbackEmail) {
  return data.name || data.contact_name || data.business_name || data.email || fallbackEmail || '';
}

// Shared continuation of every login (password and Google): from a signed-in Firebase user to the
// users doc, the account and the localStorage keys the rest of the panel reads.
// extra: { photo } (Google picture when signed in with Google).
export function* establishSession(user, extra = {}) {
  const filter = { field: 'uid', operator: '==', value: user.uid };
  let data = yield call(simpleQueryFirestoreWithFilter, COLLECTION_NAME, [filter]);
  data = Object.values(data || {})[0];
  if (!data) {
    const error = new Error('No users document for this account');
    error.code = 'app/no-profile';
    throw error;
  }
  const filterAccount = { field: 'id', operator: '==', value: data.accountId ? data.accountId : '' };
  let dataAccount = yield call(simpleQueryFirestoreWithFilter, COLLECTION_NAME_ACCOUNT, [filterAccount]);
  dataAccount = Object.values(dataAccount || {})[0];
  const firebaseToken = yield call([user, user.getIdToken]);
  const email = (user.email || data.email || '').toLowerCase();
  localStorage.setItem('id_token', firebaseToken);
  localStorage.setItem('id_role', data.role);
  localStorage.setItem('id_user', data.id);
  localStorage.setItem('user_name', displayNameOf(data, email));
  localStorage.setItem('user_email', email);
  if (extra.photo) localStorage.setItem('user_photo', extra.photo);
  else localStorage.removeItem('user_photo');
  if (data.accountId) localStorage.setItem('account_id', data.accountId);
  if (dataAccount) localStorage.setItem('data_account', JSON.stringify(dataAccount));
  if (data.agencyIsActive) localStorage.setItem('agency_is_active', data.agencyIsActive.toString());
  return { firebaseToken, role: data.role, agencyIsActive: data.agencyIsActive, userId: data.id };
}
